import React from "react";
import { X } from "lucide-react";

import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogClose,
} from "@/components/ui/Modal";
import { ButtonShadcn as Button } from "@/components/ui/Button";

// The scaffolding the three read-only detail drawers share: a header with a
// title and a subtitle, a scrolling body, and a single Close.
//
// The action modals on this screen each own their own copy of this shape
// because each one also owns a confirmation gate, a result list and an in-flight
// state that must not be dismissed. These drawers have none of that — they only
// read — so one shell serves all three, and a change to the way a drawer looks
// happens once.
const DetailDrawer = ({ open, title, subtitle, onClose, children }) => (
    <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
        <DialogContent className="w-[340px] md:w-[720px] max-h-[85vh] flex flex-col">
            <DialogHeader className="relative px-5 py-3 border-b border-border-primary shrink-0">
                <DialogTitle className="text-[15px] font-semibold text-text-primary pr-8">
                    {title}
                </DialogTitle>
                {subtitle && (
                    <DialogDescription className="text-[12px] text-text-secondary mt-0.5 pr-8">
                        {subtitle}
                    </DialogDescription>
                )}
                <DialogClose
                    aria-label="Close"
                    className="absolute right-5 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-background-icon/40 flex items-center justify-center"
                >
                    <X size={16} strokeWidth={3} aria-hidden="true" />
                </DialogClose>
            </DialogHeader>

            <div className="flex-1 overflow-y-auto custom-scrollbar px-5 py-4 space-y-4">
                {children}
            </div>

            <div className="border-t border-border-primary px-5 py-3 flex justify-end">
                <DialogClose
                    render={
                        <Button variant="outline" type="button">
                            Close
                        </Button>
                    }
                />
            </div>
        </DialogContent>
    </Dialog>
);

export default DetailDrawer;
